<div class="container">
  <mat-card class="card">
    <mat-card-header>
      <mat-card-title>{{ 'Collections.Title' | translate }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <mat-selection-list #names [multiple]="false">
        <mat-list-option *ngFor="let collectionName of collectionNames" (click)="chooseCollection(collectionName)">
        {{collectionName}}
        </mat-list-option>
      </mat-selection-list>
    </mat-card-content>
    <mat-card-actions>
      <button class="next-button" mat-raised-button color="primary" (click)="next()" [disabled]="!collectionName">{{ 'Next' | translate }}</button>
    </mat-card-actions>
  </mat-card>
</div>